import { ProjectStep } from 'src/utils/enums'

/**
 * Route-index order of the synthesis sub-pages (`synthesis/<idx>`).
 *
 * This is the *routing* order, deliberately distinct from `@autoriz/shared`'s
 * chronological `PROJECT_STEP_ORDER` (which ranks REFUSED earlier). The array
 * index is exactly the `<idx>` segment in
 * `/projects/edit/:id/synthesis/:idx` — keep in sync with `router.tsx` and the
 * `synthesis/<idx>.tsx` files.
 */
export const SYNTHESIS_STEPS = [
  ProjectStep.PROJECT_INITIALIZED, // 0
  ProjectStep.PROJECT_REQUESTED, // 1
  ProjectStep.PROJECT_ACCEPTED, // 2
  ProjectStep.PROJECT_REFUSED, // 3
  ProjectStep.PROJECT_ORDERED, // 4
  ProjectStep.PROJECT_PAIED, // 5
  ProjectStep.PROJECT_IN_PROGRESS, // 6
  ProjectStep.PROJECT_FILE_COMPLETED, // 7
  ProjectStep.PROJECT_FILE_SENT, // 8
  ProjectStep.PROJECT_FILE_SUBMITTED, // 9
  ProjectStep.PROJECT_FILE_REFUSED, // 10
  ProjectStep.PROJECT_ABANDONED, // 11
  ProjectStep.PROJECT_COMPLETED, // 12
] as const

/** Index of `step` in the synthesis route order, or -1 if unknown/absent. */
export const synthesisStepIndex = (step: string | null | undefined): number =>
  step == null ? -1 : (SYNTHESIS_STEPS as readonly string[]).indexOf(step)

/**
 * Absolute path of the synthesis sub-page for `step`. Falls back to the
 * synthesis dispatcher (`/projects/edit/:id/synthesis`) when the step is
 * unknown/absent so the index route can resolve it from fresh context.
 */
export const synthesisStepPath = (
  projectID: number,
  step: string | null | undefined,
): string => {
  const idx = synthesisStepIndex(step)
  return idx >= 0
    ? `/projects/edit/${projectID}/synthesis/${idx}`
    : `/projects/edit/${projectID}/synthesis`
}
